const LS_KEY = 'videbits-dashboard-layout';

// Strip a section down to the fields the backend persists (drops derived
// fields like notes so the saved payload matches the API schema).
function cleanSection(s) {
  return {
    id: s.id,
    type: s.type,
    title: s.title,
    visible: s.visible !== false,
    params: s.params || {},
  };
}

// Persist a dashboard layout. Authenticated users save to the API; anonymous
// users save to localStorage. Returns true on success.
export async function saveDashboardLayout({ apiBase, token, isAuthenticated, sections }) {
  const layout = { version: 1, sections: sections.map(cleanSection) };

  if (isAuthenticated && token) {
    try {
      const res = await fetch(`${apiBase}/preferences/dashboard`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(layout),
      });
      return res.ok;
    } catch (_) {
      return false;
    }
  }

  try {
    localStorage.setItem(LS_KEY, JSON.stringify(layout));
    return true;
  } catch (_) {
    return false;
  }
}
